var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 216,
    viewBox: "0 0 174 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 76.1533,
    y1: 93.4892,
    x2: 27.0701,
    y2: 68.673,
    stroke: "#FF5619"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 122.948,
    y1: 75.1863,
    x2: 145.117,
    y2: 18.0414,
    stroke: "#FFC400"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 165.781,
    y1: 205.945,
    x2: 127.617,
    y2: 139.586,
    stroke: "#00AD5F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.746,
    cy: 109.743,
    r: 39.5,
    transform: "rotate(-153.179 108.746 109.743)",
    fill: "#FF5619",
    stroke: "#FF5619"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1552,
    cy: 64.6191,
    r: 14.5,
    transform: "rotate(-153.179 20.1552 64.6191)",
    fill: "#FF5619",
    stroke: "#FF5619"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.645,
    cy: 209.278,
    r: 4.5,
    transform: "rotate(-153.179 166.645 209.278)",
    fill: "#00AD5F",
    stroke: "#00AD5F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.364,
    cy: 13.685,
    r: 9.5,
    transform: "rotate(-149.589 145.364 13.685)",
    fill: "#FFC400",
    stroke: "#FFC400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.107 98.4419C121.107 98.7211 120.996 98.9888 120.799 99.1862C120.602 99.3836 120.334 99.4945 120.055 99.4945H117.949C117.67 99.4945 117.403 99.3836 117.205 99.1862C117.008 98.9888 116.897 98.7211 116.897 98.4419C116.897 98.1627 117.008 97.895 117.205 97.6976C117.403 97.5002 117.67 97.3893 117.949 97.3893H120.055C120.334 97.3893 120.602 97.5002 120.799 97.6976C120.996 97.895 121.107 98.1627 121.107 98.4419ZM129 100.263V117.526C129 119.48 128.224 121.355 126.842 122.736C125.46 124.118 123.586 124.895 121.632 124.895H96.3684C94.4142 124.895 92.54 124.118 91.1582 122.736C89.7763 121.355 89 119.48 89 117.526V100.263C89 98.3087 89.7763 96.4345 91.1582 95.0527C92.54 93.6708 94.4142 92.8945 96.3684 92.8945H121.632C123.586 92.8945 125.46 93.6708 126.842 95.0527C128.224 96.4345 129 98.3087 129 100.263ZM126.895 100.263C126.895 98.8671 126.34 97.5284 125.353 96.5413C124.366 95.5543 123.027 94.9998 121.632 94.9998H96.3684C94.9725 94.9998 93.6338 95.5543 92.6468 96.5413C91.6598 97.5284 91.1053 98.8671 91.1053 100.263V117.526C91.1053 118.922 91.6598 120.261 92.6468 121.248C93.6338 122.235 94.9725 122.789 96.3684 122.789H121.632C123.027 122.789 124.366 122.235 125.353 121.248C126.34 120.261 126.895 118.922 126.895 117.526V100.263ZM116.137 108.895C116.137 110.306 115.718 111.686 114.934 112.86C114.15 114.033 113.035 114.948 111.731 115.488C110.427 116.028 108.992 116.17 107.608 115.894C106.223 115.619 104.952 114.939 103.953 113.941C102.955 112.943 102.276 111.671 102 110.287C101.725 108.902 101.866 107.467 102.406 106.163C102.947 104.859 103.861 103.745 105.035 102.96C106.209 102.176 107.588 101.758 109 101.758C110.892 101.759 112.707 102.512 114.045 103.85C115.383 105.188 116.135 107.002 116.137 108.895ZM108.432 104.81C108.318 104.556 108.108 104.355 107.849 104.253C107.589 104.151 107.299 104.154 107.042 104.263C106.322 104.569 105.683 105.039 105.175 105.634C104.667 106.23 104.304 106.935 104.116 107.695C104.081 107.827 104.072 107.966 104.092 108.102C104.111 108.238 104.157 108.368 104.228 108.486C104.299 108.604 104.392 108.706 104.503 108.787C104.614 108.868 104.74 108.926 104.874 108.958C104.956 108.982 105.041 108.996 105.126 109C105.362 108.997 105.59 108.918 105.777 108.773C105.963 108.629 106.097 108.427 106.158 108.2C106.265 107.756 106.476 107.344 106.772 106.996C107.068 106.649 107.442 106.376 107.863 106.2C108.118 106.085 108.319 105.877 108.425 105.619C108.531 105.36 108.533 105.071 108.432 104.81Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconGroup);
export default __webpack_public_path__ + "static/media/camera-icon-group.7cf6f8eb7718380c41d207676aad88d7.svg";
export { ForwardRef as ReactComponent };